import React, { useRef, useEffect,useContext } from "react";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { downloadPdfReport } from "../../../../service/StudyReportService";
import { t } from "i18next";
import { ADVANCE_VIEWER_MODALITIES, NONXRAYMODALITIES, VDCLIMS } from "../../../../constants/Constants";
import ConfirmModal from "../../../../components/Modal/ConfirmModal";
import { getPaymentStatusOfStudy } from "../../../../service/StudyListService";
import { useState } from "react";
import themeContext from "../../../../context/theme/ThemeContext";
import { getEnv } from '../../../../helpers/EnvHelper';

const DownloadOptions = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const ref = useRef(null);
  const { onClickOutside } = props;

  const currentUrl = window.location.href;
  const containsStudyList = currentUrl.includes('studylist');

  const {
    downloadReport
  } = useContext(studyReportContext);

  const [paymentStatusOfStudy, setPaymentStatusOfStudy] = useState(0);
  const [paymentMessageOfStudy, setPaymentMessageOfStudy] = useState("");
  const [showPaymentAlertModal, setShowPaymentAlertModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const aiReportOptions = props.aiReportOptions != null && props.aiReportOptions != undefined ? props.aiReportOptions : false
  const reportOptions = props.reportOptions != null && props.reportOptions != undefined ? props.reportOptions : true
  const peerReviewReportOptions = props.peerReviewReportOptions != null && props.peerReviewReportOptions != undefined ? props.peerReviewReportOptions : false;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowPaymentAlertModal(false);
        setShowConfirmModal(false);
        setPaymentMessageOfStudy("");
        setPaymentStatusOfStudy(0);
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  if (!props.show) return null;

  const handleDownloadReport = async(type, studyId) =>{
    downloadReport(type, studyId, props.useDraftSnapshot === true);

  }

  const handlePaymentAlertModal = () =>{
    setShowPaymentAlertModal(false);
    setShowConfirmModal(false);
    setPaymentMessageOfStudy("");
    setPaymentStatusOfStudy(0);
  }

  const handleDownloadOptions = (type, isExtReportReceived) =>{
    if(!isExtReportReceived){
      if(type != "pdfwithimage"){
        return true;
      }
      else if(type == "pdfwithimage" && props.modality != null && props.modality != undefined && !ADVANCE_VIEWER_MODALITIES.includes(props.modality)){
         return true;
      }
    } else if(isExtReportReceived && type == "pdf" && props.modality != null && props.modality != undefined ){
      return true;
    } else if(isExtReportReceived && (type == "pdfwithkeyimage" || type == "keyimagesonly" || type == "keyimagesonlydocx") && props.modality != null && props.modality != undefined && !NONXRAYMODALITIES.includes(props.modality)){
      return true;
    } else if(isExtReportReceived && type == "pdfwithimage" && props.modality != null && props.modality != undefined && !ADVANCE_VIEWER_MODALITIES.includes(props.modality)){
      return true;
    }
    return false;
  }

  // A report download is shown only when reportOptions is on and the option is
  // valid for the current study/modality (existing handleDownloadOptions logic).
  const canShow = (type) =>
    reportOptions && handleDownloadOptions(type, props.isExtReportReceived);

  // DOC/DOCX (Word) formats are only offered on non-VDC platforms.
  const showWord = getEnv("REACT_APP_VDC_PLATFORM") == "false";

  // Layout grouped by intent (rows) × format (chips). Columns ordered
  // PDF → DOCX → DOC since PDF supports every option.
  const downloadRows = [
    {
      labelKey: "hospital.row-report",
      items: [
        { type: "pdf", labelKey: "hospital.pdf" },
        { type: "docx", labelKey: "hospital.docx", word: true },
        { type: "doc", labelKey: "hospital.doc", word: true },
      ],
    },
    {
      labelKey: "hospital.row-with-key-images",
      highlightOnKeyImages: true,
      items: [
        { type: "pdfwithkeyimage", labelKey: "hospital.pdf" },
        { type: "docxwithkeyimage", labelKey: "hospital.docx", word: true },
      ],
    },
    {
      labelKey: "hospital.row-with-study-images",
      items: [
        { type: "pdfwithimage", labelKey: "hospital.pdf" },
      ],
    },
    {
      labelKey: "hospital.row-key-images-only",
      highlightOnKeyImages: true,
      requiresKeyImages: true,
      items: [
        { type: "keyimagesonly", labelKey: "hospital.pdf" },
        { type: "keyimagesonlydocx", labelKey: "hospital.docx", word: true },
      ],
    },
  ];

  return (
    <div ref={ref} className={props.isStudyList != null && props.isStudyList != undefined && props.isStudyList == true?"download-options-study-list":"download-options"} style={{backgroundColor: "transparent", top: '', bottom: '32px'}}>
      {showPaymentAlertModal &&
        <ConfirmModal handleConfirm={handlePaymentAlertModal} handleNotConfirm={handlePaymentAlertModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={paymentMessageOfStudy}
          title={t("confirm-message.alert")} confirmButtonText={t("confirm-message.ok")} cancelButtonText={t("confirm-message.cancel")}/>
      }
      <div
        className="download-options-menu"
        style={{
          color: getThemeColor("primary-color"),
          // This menu can render through a Fluent <Modal> portal on <body> (external
          // reporting), outside the [data-theme] root — so the theme CSS vars don't
          // cascade in and the background falls back to transparent (white text becomes
          // invisible). Supply the vars inline so the existing CSS resolves everywhere.
          backgroundColor: getThemeColor("popup-background"),
          "--popup-background": getThemeColor("popup-background"),
          "--navbar-header-popup-item-hover": getThemeColor("popup-hover"),
        }}
      >
        {aiReportOptions && (
          <button
            type="button"
            className="download-menu-item-full download-menu-item-divider"
            id="ai-report"
            onClick={() => { props.downloadAIReport(props.studyParentId) }}
          >
            {t("heading.download-ai-report")}
          </button>
        )}

        {downloadRows.map((row) => {
          // "Key images only" is meaningless without key images — hide the row.
          if (row.requiresKeyImages && !props.isKeyImagesPresent) return null;
          const visibleItems = row.items.filter(
            (it) => canShow(it.type) && (it.word ? showWord : true)
          );
          if (visibleItems.length === 0) return null;
          return (
            <div className="download-row" key={row.labelKey}>
              <span
                className={`download-row-label${
                  row.highlightOnKeyImages && props.isKeyImagesPresent ? " download-row-label-highlight" : ""
                }`}
              >
                {t(row.labelKey)}
              </span>
              <div className="download-row-chips">
                {visibleItems.map((it) => (
                  <button
                    type="button"
                    key={it.type}
                    id={it.type}
                    className="download-chip"
                    onClick={() => { handleDownloadReport(it.type, props.studyParentId) }}
                  >
                    {t(it.labelKey)}
                  </button>
                ))}
              </div>
            </div>
          );
        })}

        {peerReviewReportOptions && handleDownloadOptions("peerReview", props.isExtReportReceived) && (
          <button
            type="button"
            className="download-menu-item-full"
            id="peer-review"
            onClick={() => { handleDownloadReport("peerReview", props.studyParentId) }}
          >
            {t("hospital.peer-review")}
          </button>
        )}
      </div>
    </div>
  );
};

export default DownloadOptions;


 {/* <Dialog
        hidden={hideDialog}
        onDismiss={setToggleHideDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
        <DialogFooter>
          <PrimaryButton onClick={setToggleHideDialog} text="Send" />
          <DefaultButton onClick={setToggleHideDialog} text="Don't send" />
        </DialogFooter>
      </Dialog> */}

    // const dragOptions = {
  //   moveMenuItemText: 'Move',
  //   closeMenuItemText: 'Close',
  //   menu: ContextualMenu,
  // };
  // const dialogContentProps = {
  //   type: DialogType.normal,
  //   title: 'Missing Subject',
  //   subText: 'Do you want to send this message without a subject?',
  // };

  // const modalPropsStyles = { main: { maxWidth: 450 } };

  // const modalProps = 
  //   () => ({
  //     isBlocking: true,
  //     styles: modalPropsStyles,
  //     dragOptions: isDraggable ? dragOptions : undefined,
  //   });
